import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import React from 'react';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const UserFormUploadName = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    const updatedClasses = classes.push('w-file-upload-file-name');
    return (
      <div {...generateAttributes(attributes, updatedClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </div>
    );
  }
);
const config = createIntegratedAtom({
  displayName: 'Text Block',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: true,
  render: UserFormUploadName,
  fields: {children: TListOfElement},
});

export default config;
